var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"nejm",on:{"click":_vm.onNejmClick}},[_c('h3',{staticClass:"title"},[_vm._v("NEJM目录")]),_vm._l((_vm.mulvList),function(item,i){return _c('a',{key:i,staticClass:"nejm-txt",domProps:{"innerHTML":_vm._s(_vm.replaceHandle(item.title, `<br>`))}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }